<div class="profile">
    <div class="row ">
        <div class="profile-photo col-sm-3 col-xs-12">
            <img src="../../../assets/sakshi_profile_pic.png" class="img-circle" alt="avatar">
        </div>
        <div class=" profile-info col-sm-7 col-sm-offset-2 col-xs-12">
            <div class="row justify-content-center">
                <div class="col-xs-12">
                    <p>Sakshi Bhardwaj</p>
                </div>
                
            </div>
            <div class="row justify-content-center">
                <div class="col-xs-12 text-xs-center text-sm-left">
                   <p>Assistant Professor of Economics at <br>
                    Universty of Wisconsin-Whitewater</p> 
                </div>
                
            </div>
            
            <div class="row justify-content-center">
                <div class="col-xs-12 text-xs-center text-sm-left">
                    <p>Email:   <a href="mailto:bhardwas@uww.edu">bhardwas@uww.edu</a></p>
                </div>
                
            </div>
            <div class="row justify-content-center">
                <div class="col-xs-12 text-xs-center text-sm-left">
                    <a href="../../../assets/Bhardwaj_Sakshi_CV.pdf" target="_blank">CV</a>
                </div>
                
            </div>

            <div class="row justify-content-center">
                <div class="col-xs-2 social-media-item">
                    
                    <a href="https://scholar.google.com/citations?hl=en&user=PZ-PxsMAAAAJ&view_op=list_works&sortby=pubdate"
             target="_blank">
             <i class="icon ai ai-google-scholar-square  ai-2x" style="color: #4285f4;"></i>
            </a> 
                </div>
                <div class="col-xs-2 social-media-item">
                    
                    <a href="https://www.linkedin.com/in/sakshi-bhardwaj-b43a9535/"
             target="_blank">
             <i class="fab fa-linkedin fa-2x" aria-hidden="true" style="color: #0e76a8;"></i>
            </a> 
                </div>
                <div class="col-xs-2 social-media-item">
                    
                    <a href="https://twitter.com/Sakshi_Econ"
             target="_blank">
             <i class=" fab fa-twitter-square fa-2x" style="color: #00acee;"></i>
            </a> 
                </div>

                <div class="col-xs-2 social-media-item">
                    
                    <a href="https://bsky.app/profile/sakshibhardwaj.bsky.social"
             target="_blank">
             <i class="fab fa-square-bluesky fa-2x" style="color: lightblue;"></i>
            </a> 
                </div>
               <div class="social-media-item">
       
            
      
    </div>
            </div>
            
            
            
        </div>    
    </div>
</div>
